import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  title: {
    id: 'Pricing.title',
    defaultMessage: 'Pricing',
  },
  description: {
    id: 'Pricing.description',
    defaultMessage:
      "Whether you're hosting a wedding, birthday, funeral, or any other special event, our guestbooks are designed to capture memories in a beautiful and convenient way. Explore our pricing options below and find the perfect fit for your event.",
  },
})
